import React from 'react';
import { motion } from 'framer-motion';
import { Instagram, Facebook, Mail } from 'lucide-react';
import { Link } from 'react-router-dom';

export const Footer = () => {
  const scrollToSection = (e, href) => {
    e.preventDefault();
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="relative bg-[#0a1628] border-t border-white/10">
      <div className="container mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">
          {/* Brand */}
          <div className="col-span-1 md:col-span-2">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
              viewport={{ once: true }}
            >
              <div className="inline-block bg-white rounded-2xl px-6 py-4 mb-4 shadow-xl shadow-[#7dd3fc]/30 border border-[#7dd3fc]/40">
                <img 
                  src="https://customer-assets-4nw71qhi.emergentagent.net/job_flavored-ice-factory/artifacts/iyqyn1tc_IMG_3682.png"
                  alt="Império Ice"
                  className="h-20 w-auto object-contain"
                />
              </div>
              <p className="text-white/60 leading-relaxed mb-6 max-w-md">
                Qualidade premium em gelos saborizados. Transformando cada momento em uma experiência refrescante única.
              </p>
              <div className="flex gap-4">
                <motion.a
                  href="https://instagram.com/imperio.ice__"
                  target="_blank"
                  rel="noopener noreferrer"
                  whileHover={{ scale: 1.1, y: -3 }}
                  whileTap={{ scale: 0.9 }}
                  className="w-10 h-10 bg-[#7dd3fc]/10 rounded-lg flex items-center justify-center hover:bg-[#7dd3fc]/20 transition-colors duration-300"
                >
                  <Instagram className="text-[#7dd3fc]" size={18} />
                </motion.a>
                <motion.a
                  href="#"
                  whileHover={{ scale: 1.1, y: -3 }}
                  whileTap={{ scale: 0.9 }}
                  className="w-10 h-10 bg-[#7dd3fc]/10 rounded-lg flex items-center justify-center hover:bg-[#7dd3fc]/20 transition-colors duration-300"
                >
                  <Facebook className="text-[#7dd3fc]" size={18} />
                </motion.a>
                <motion.a
                  href="mailto:comercial@imperioice.com.br"
                  whileHover={{ scale: 1.1, y: -3 }}
                  whileTap={{ scale: 0.9 }}
                  className="w-10 h-10 bg-[#7dd3fc]/10 rounded-lg flex items-center justify-center hover:bg-[#7dd3fc]/20 transition-colors duration-300"
                >
                  <Mail className="text-[#7dd3fc]" size={18} />
                </motion.a>
              </div>
            </motion.div>
          </div>

          {/* Quick Links */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.1 }}
            viewport={{ once: true }}
          >
            <h4 className="text-white font-bold text-lg mb-6">Links Rápidos</h4>
            <ul className="space-y-3">
              {[
                { name: 'Início', href: '#hero' },
                { name: 'Sobre Nós', href: '#about' },
                { name: 'Produtos', href: '#products' },
                { name: 'Revendedores', href: '#resellers' },
              ].map((link) => (
                <li key={link.name}>
                  <a
                    href={link.href}
                    onClick={(e) => scrollToSection(e, link.href)}
                    className="text-white/60 hover:text-[#7dd3fc] transition-colors duration-300 inline-block"
                  >
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </motion.div>

          {/* Contact Info */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            viewport={{ once: true }}
          >
            <h4 className="text-white font-bold text-lg mb-6">Contato</h4>
            <ul className="space-y-3 text-white/60">
              <li>
                <a href="mailto:comercial@imperioice.com.br" className="hover:text-[#7dd3fc] transition-colors duration-300" data-testid="footer-email-link">
                  comercial@imperioice.com.br
                </a>
              </li>
              <li>(11) 98191-9933</li>
              <li>Rua Segundo Sargento Ananias Holanda de Oliveira, nº 19</li>
              <li>São Paulo/SP</li>
              <li className="text-white/40 text-sm pt-2">CNPJ: 63.234.127/0001-95</li>
            </ul>
          </motion.div>
        </div>

        {/* Bottom Bar */}
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 0.6, delay: 0.3 }}
          viewport={{ once: true }}
          className="pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between items-center gap-4"
        >
          <p className="text-white/40 text-sm text-center md:text-left">
            © 2026 Império Ice Ltda. Todos os direitos reservados.
          </p>
          <div className="flex items-center gap-6">
            <Link to="/termos" className="text-white/40 text-sm hover:text-[#7dd3fc] transition-colors duration-300" data-testid="footer-terms-link">
              Termos de Uso
            </Link>
            <Link to="/privacidade" className="text-white/40 text-sm hover:text-[#7dd3fc] transition-colors duration-300" data-testid="footer-privacy-link">
              Privacidade
            </Link>
          </div>
        </motion.div>
      </div>
    </footer>
  );
};
